import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { IBizEntity } from '@optima-stride-ai/core';

/**
 * Event bus service for library thumbnail context menu events
 * This allows thumbnail components to emit events that can be captured
 * by the parent library page component
 */
@Injectable({
  providedIn: 'root'
})
export class LibraryThumbnailEventService {
  private menuRequestedSubject = new Subject<{ event: MouseEvent; entity: IBizEntity }>();
  
  menuRequested$ = this.menuRequestedSubject.asObservable();
  
  emitMenuRequested(event: MouseEvent, entity: IBizEntity) {
    this.menuRequestedSubject.next({ event, entity });
  }
}
